import throttle from "lodash-es/throttle";

let w = window;
let previous = w.scrollY;
let $w = $(w);

w.addEventListener(
  "scroll",
  throttle(() => {
    let y = w.scrollY;

    window.PubSub.publish("window:scroll", {
      top: y,
      direction: y > previous ? "down" : "up"
    });

    previous = y;
  }, 50)
);

w.addEventListener(
  "resize",
  throttle(function() {
    window.PubSub.publish("window:resize", {
      width: $w.width(),
      height: $w.height()
    });
  }, 100)
);



// WEBPACK FOOTER //
// ./scripts/lib/window-scroll-events.js